import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';
import { ArrowLeft, Save } from 'lucide-react';
import { Form, Button, Card, Container, Row, Col } from 'react-bootstrap';
import { toUpperCase } from '../utils/formatters';

const ServiceForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [formData, setFormData] = useState({ name: '', description: '', duration: '00:30:00', price: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            fetchService();
        }
    }, [id]);

    const fetchService = async () => {
        try {
            const response = await api.get(`/services/${id}/`);
            setFormData(response.data);
        } catch (error) {
            console.error('Error fetching service:', error);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (id) {
                await api.put(`/services/${id}/`, formData);
            } else {
                await api.post('/services/', formData);
            }
            navigate('/services');
        } catch (error) {
            console.error('Error saving service:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="py-2">
            <div className="d-flex align-items-center mb-4">
                <Button
                    variant="link"
                    onClick={() => navigate('/services')}
                    className="text-decoration-none text-secondary p-0 me-3 d-flex align-items-center gap-2"
                >
                    <ArrowLeft size={20} /> Voltar
                </Button>
                <h2 className="mb-0">{id ? 'Editar Serviço' : 'Novo Serviço'}</h2>
            </div>

            <Card className="shadow-sm border-0">
                <Card.Body className="p-4">
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: toUpperCase(e.target.value) })}
                                        required
                                        placeholder="Nome do serviço"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Preço (R$)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={formData.price}
                                        onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                                        required
                                        placeholder="0.00"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Label>Duração (HH:MM:SS)</Form.Label>
                            <Form.Control
                                value={formData.duration}
                                onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                                required
                                placeholder="00:30:00"
                            />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: toUpperCase(e.target.value) })}
                                placeholder="Detalhes do serviço..."
                            />
                        </Form.Group>

                        <div className="d-flex justify-content-end">
                            <Button
                                variant="primary"
                                type="submit"
                                disabled={loading}
                                className="d-flex align-items-center gap-2 px-4"
                            >
                                <Save size={18} /> Salvar
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ServiceForm;
